/* =========================================================================
   Penny Premium 3D — recently-viewed.js
   Two jobs, one tiny module:
   1. On product pages: record the current product in localStorage
      (key 'penny:recently-viewed', newest first, deduped by handle,
      capped at 12).
      Stored shape: { handle, url, title, price, image, ratio }
      — price is the server-formatted string, image a 600px CDN URL,
      ratio the image aspect ratio (for the reserved frame).
   2. Where sections/recently-viewed.liquid exists: render the list
      (excluding the current product) into the shared slider pattern and
      reveal the section. The section stays display:none until then —
      collapse-safe, no CLS, no empty-state flash.
   ========================================================================= */

const KEY = 'penny:recently-viewed';

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch (_) {
    return [];
  }
};

/* --- Record --------------------------------------------------------------- */
const store = document.querySelector('[data-recently-viewed-store]');
if (store) {
  try {
    const item = JSON.parse(store.textContent);
    const list = [item, ...read().filter((p) => p.handle !== item.handle)].slice(0, 12);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (_) {
    /* storage unavailable — feature silently off */
  }
}

/* --- Render ---------------------------------------------------------------- */
const section = document.querySelector('[data-recently-viewed]');
if (section) {
  const exclude = section.dataset.exclude;
  const items = read().filter((p) => p.handle !== exclude).slice(0, 8);

  if (items.length > 0) {
    const track = section.querySelector('[data-recently-viewed-track]');
    track.replaceChildren(
      ...items.map((item) => {
        const li = document.createElement('li');
        li.className = 'slider__item';
        // Same classes as product-card so the styling is identical.
        // Link-only cards: no quick-add (variant state isn't stored).
        li.innerHTML = `
          <article class="product-card">
            <div class="product-card__frame">
              <div class="media product-card__media" style="aspect-ratio: 4 / 5;"></div>
            </div>
            <div class="product-card__info">
              <h3 class="product-card__title">
                <a class="product-card__title-link" href=""></a>
              </h3>
              <p class="product-card__price"></p>
            </div>
          </article>`;
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 600;
        img.height = 750;
        const link = li.querySelector('a');
        link.href = item.url;
        link.textContent = item.title;
        li.querySelector('.product-card__price').textContent = item.price;
        if (item.image) li.querySelector('.media').append(img);
        return li;
      })
    );

    section.classList.add('is-ready');
    document.dispatchEvent(new Event('shopify:section:load'));
  }
}
